import { queryClient } from "@/queryClient"
import api from "@/services/api"
import {
  BASE_ORDERS_QUERY_KEY,
  BASE_TRANSACTIONS_QUERY_KEY,
} from "../queryKeys"
import type { CardTransactionData } from "@/androidPlugins/IPayment"

export const voidTransaction = async (
  transactionId: string,
  params?: CardTransactionData
) => {
  await api.post(
    `/transactions/${transactionId}/void-transaction/`,
    {
      body: {
        data: params,
      },
    }
  )

  queryClient.invalidateQueries({
    queryKey: [BASE_ORDERS_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [BASE_TRANSACTIONS_QUERY_KEY],
  })
}
